import { useState } from "react";

export const useSelect = ({
  options,
  defaultValue,
  onChange,
  onReset,
}: {
  options: { label: string; value: string }[];
  defaultValue: string;
  onChange?: (value: string) => void;
  onReset?: () => void;
}) => {
  const [value, setValue] = useState<string>(defaultValue);

  const handleOnChange = (event: any) => {
    setValue(event.target.value as string);
    if (onChange) {
      onChange(event.target.value as string);
    }
  };

  const reset = () => {
    setValue(defaultValue);
    if (onReset) {
      onReset();
    }
  };

  return { defaultValue, value, setValue, handleOnChange, options, reset };
};
